import MuiAutocomplete, {
  type AutocompleteProps,
} from "@mui/material/Autocomplete";

export type { AutocompleteProps };

export function Autocomplete<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>(
  props: AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo>,
) {
  return <MuiAutocomplete {...props} />;
}
